// /Users/redis/Downloads/custom-posting-ui/frontend/src/components/layout/BottomNavigationBar.jsx
import React from 'react';
import { NavLink } from 'react-router-dom';
import Icon from '../common/Icon';
import { PATHS } from '../../router.jsx';
import { useModal } from '../../contexts/ModalContext';
import { MODAL_TYPES } from '../common/GlobalModals';

const BottomNavigationBar = () => {
  const { openModal } = useModal();

  const handleCreateButtonClick = (e) => {
    e.preventDefault();
    openModal(MODAL_TYPES.CREATE_NEW_CONTENT_SELECTION);
  };

  // ALL STYLES AS OBJECTS - NO CSS FILES
  const navStyle = {
    display: 'flex',
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    height: '60px',
    backgroundColor: '#2F81F7',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 8px',
    zIndex: 99999,
    boxShadow: '0 -4px 12px rgba(0,0,0,0.3)',
    borderTop: '1px solid rgba(255,255,255,0.1)'
  };

  const itemStyle = {
    flex: '1 1 0%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    textDecoration: 'none',
    padding: '8px 4px',
    cursor: 'pointer',
    border: 'none',
    background: 'transparent',
    minWidth: '50px'
  };

  const iconWrapperStyle = {
    fontSize: '1.5rem',
    marginBottom: '4px',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  };

  const textStyle = {
    fontSize: '0.7rem',
    color: 'white',
    fontWeight: '500'
  };

  const createButtonStyle = {
    ...itemStyle,
    flex: '0 0 60px'
  };

  const createIconStyle = {
    backgroundColor: 'white',
    color: '#2F81F7',
    borderRadius: '50%',
    width: '50px',
    height: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '2rem'
  };

  return (
    <nav 
      style={navStyle}
      role="navigation" 
      aria-label="Main navigation"
    >
      <NavLink to={PATHS.HOME} style={itemStyle} aria-label="Home">
        <div style={iconWrapperStyle}>
          <Icon name="home" size={24} />
        </div>
        <span style={textStyle}>Home</span>
      </NavLink>
      
      <NavLink to={PATHS.EXPLORE} style={itemStyle} aria-label="Explore">
        <div style={iconWrapperStyle}>
          <Icon name="compass" size={24} />
        </div>
        <span style={textStyle}>Explore</span>
      </NavLink>
      
      <div 
        role="button"
        tabIndex={0}
        style={createButtonStyle}
        aria-label="Create new content"
        onClick={handleCreateButtonClick}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleCreateButtonClick(e);
          }
        }}
      >
        <div style={createIconStyle}>
          <Icon name="plus" size={32} />
        </div>
      </div>
      
      <NavLink to={PATHS.EVENTS_MAP} style={itemStyle} aria-label="Events Map">
        <div style={iconWrapperStyle}>
          <Icon name="map" size={24} />
        </div>
        <span style={textStyle}>Map</span>
      </NavLink>
      
      <NavLink to={PATHS.VIDEO_REELS} style={itemStyle} aria-label="Video Reels">
        <div style={iconWrapperStyle}>
          <Icon name="play-circle" size={24} />
        </div>
        <span style={textStyle}>Reels</span>
      </NavLink>
      
      <NavLink to={PATHS.MORE} style={itemStyle} aria-label="More options">
        <div style={iconWrapperStyle}>
          <Icon name="ellipsis-h" size={24} />
        </div>
        <span style={textStyle}>More</span>
      </NavLink>
    </nav>
  );
};

export default BottomNavigationBar;
